import header from "./hand-holding-keys-outdoors.jpg";
import section1 from "./closeup-man-holding-key-his-new-home.jpg";
import section2 from "./keys-being-held-by-real-estate-agent-buyer.jpg";
import section3 from "./happy-insurance-agent-communicating-with-her-clients.jpg";
import section4 from "./key-money-hands-front-home-building.jpg";
import section5 from "./real-estate-contract-table.jpg";
import section6 from "./couple-enjoying-view-from-their-new-home.jpg";
import section7 from "./real-estate-agent-discussion-about-house-contracts.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
